import { ActionType, createAction, createAsyncAction } from 'typesafe-actions';

import {
  GetProviderPortalAccountInfoResponse,
  GetProviderPortalCampaignAccountInfoResponse,
} from './types';

export const requestAccountInfoAsyncAction = createAsyncAction(
  '@accountInfo/GET_DETAILS',
  '@accountInfo/GET_DETAILS_SUCCESS',
  '@accountInfo/GET_DETAILS_FAILURE',
)<void, GetProviderPortalAccountInfoResponse, Error>();

export const requestAccountCampaignInfoAsyncAction = createAsyncAction(
  '@accountInfo/GET_ACCOUNT_CAMPAIGN_INFO',
  '@accountInfo/GET_ACCOUNT_CAMPAIGN_INFO_SUCCESS',
  '@accountInfo/GET_ACCOUNT_CAMPAIGN_INFO_FAILURE',
)<void, GetProviderPortalCampaignAccountInfoResponse, Error>();

export const selectProviderAction = createAction('@accountInfo/SELECT_PROVIDER')<
  number | undefined
>();

export type AccountActions =
  | ActionType<typeof requestAccountInfoAsyncAction>
  | ActionType<typeof requestAccountCampaignInfoAsyncAction>
  | ActionType<typeof selectProviderAction>;
